import styled from "styled-components";

export const Container = styled.div`
    margin-top: -1px;
    width: 100%;
`;

// Same padding-bottom nudge as devices/Table.sc's SwitchContainer (which this used to be cross-imported from),
// tuned to bottom-align the switch with the other filter inputs in a row using `align-items: flex-end`. Kept
// local (rather than re-importing the devices version) since "Gelöschte anzeigen" is noticeably longer than
// devices' label and would otherwise be free to wrap on narrower columns and throw the alignment off; nowrap
// keeps this column's content the same single-line shape the padding value was tuned against.
export const SwitchContainer = styled.div`
    padding-bottom: 10px;

    .MuiFormControlLabel-label {
        white-space: nowrap;
    }
`;
